import { forwardRef } from 'react'

import { SnackbarContent, SnackbarKey, SnackbarMessage, VariantOverrides } from 'notistack'

import CloseIcon from '~/images/icons/SystemOutlined/Close.svg'
import { useSnackbar } from '~/libs/notistack'

type DetailedInfoProps = VariantOverrides['detailedInfo']
interface DetailedInfoSnackbarProps extends DetailedInfoProps {
  id: SnackbarKey
  message: SnackbarMessage
}

const DetailedInfoSnackbar = forwardRef<HTMLDivElement, DetailedInfoSnackbarProps>(
  ({ message, id, description }, ref) => {
    const { closeSnackbar } = useSnackbar()
    return (
      <SnackbarContent ref={ref} id={id as string} style={{ display: 'grid' }}>
        <div
          className='relative flex flex-col p-6 pt-10  max-w-[360px] rounded-lg'
          style={{
            background: 'linear-gradient(180deg, #ffffff -12.81%, #36ccc1 215%)',
            boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.06), 0px 3px 19px 0px rgba(0, 0, 0, 0.15)',
          }}
        >
          <h1 className='text-body-text-2 font-semibold'>{message}</h1>
          <div className='text-caption-1'>{description}</div>
          <CloseIcon
            title='close-message'
            onClick={() => closeSnackbar()}
            className='text-icon-subdued cursor-pointer w-[24px] h-[24px] min-w-[24px] absolute top-2 right-2'
          />
        </div>
      </SnackbarContent>
    )
  },
)

export default DetailedInfoSnackbar
